import React, { useState } from "react";
import { setEditorSaved } from "../../../../../../../redux/actions/integrationActions";
import { useDispatch, useSelector } from "react-redux";
import Button from "@atlaskit/button/new";
import Select from "@atlaskit/select";
import { Flex, Flex1, Flex2, Flex5 } from "../../../../../../../common/style";
import { ConditionType } from "../../../../../../../common/interfaces/flow/condition/ConditionType";
import { createCondition } from "../../../../../../../common/factory/condition.factory";
import DeleteIcon from "@atlaskit/icon/core/delete";

const CONDITION_TYPES = [
  { label: "Data Condition", value: ConditionType.DATA_CONDITION },
  {
    label: "HTTP Status Condition",
    value: ConditionType.HTTP_STATUS_CODE_CONDITION,
  },
];
const ConditionControl = ({ conditions, addCondition, title, removeCombinedCondition, index }) => {
  const [conditionTypeSelectOption, setConditionTypeSelectOption] = useState(
    CONDITION_TYPES[0]
  );
  const dispatch = useDispatch();
  const saved = useSelector((state) => state.integration.saved);
  const onChangeConditionType = (selected) => {
    setConditionTypeSelectOption(selected);
  };
  const onAddCondition = () => {
    const newCondition = createCondition(conditionTypeSelectOption.value);
    conditions ? conditions.push(newCondition) : (conditions = [newCondition]);
    if (saved) {
      dispatch(setEditorSaved(false));
    }
    addCondition(conditions);
  };



  return (
    <Flex>
      <Flex2>
        <Select
          options={CONDITION_TYPES}
          spacing="compact"
          name="selectConditionType"
          className="ihub-action-condition-select-combined"
          value={conditionTypeSelectOption}
          onChange={onChangeConditionType}
        />
      </Flex2>
      <Flex5>
        &ensp;&ensp;
        <Button onClick={onAddCondition} appearance="primary">
          {title}
        </Button>
        {conditions?.length === 0 && (
          <>
            &ensp;&ensp;
            <Button iconBefore={DeleteIcon} onClick={() => removeCombinedCondition(index)} />
             
          </>
        )}
      </Flex5>
    </Flex>
  );
};

export default ConditionControl;
